import React, { Component } from "react";
import { StyleSheet, Text, View, } from "react-native";
import { Body, Button, Container, Left, Right, Title } from "native-base";
import Header from "../../components/ui/WrappedHeader";
import { Translation } from "react-i18next";
import Icon from "react-native-vector-icons/Ionicons";
import LoadingIndicator from "./LoadingIndicator";
import { NavigationService } from "../../navigation";
import NavigateActionTypes from "../../navigation/NavigateActionTypes";

import UIDs from "../../UIDs";

const uid = UIDs.components.ui.screenloadingindicator;

class ScreenLoadingIndicator extends Component {
    render() {
        return (
            <Container>
                <Header style={[styles.headerColor]}>
                    <Left style={{ flex: 1 }} >
                        <Button transparent onPress={() => this._handleBack()}>
                            <Icon name="ios-arrow-back" style={[ styles.headerIcon]}/>
                        </Button>
                    </Left>
                    <Body style={{ flex: 3, justifyContent: "center", alignItems: "center" }}>
                        <Title style={[styles.headerText]}>{this.props.title ? this.props.title : null}</Title>
                    </Body>
                    <Right style={{ flex: 1 }} />
                </Header>
                <View style={{ justifyContent: "center", alignItems: "center", flex: 1, zIndex: -1 }}>
                    <View style={{marginTop: 300}}>
                        <Text style={{fontSize: 16}}><Translation ns={uid}>{(t) => t("title")}</Translation></Text>
                    </View>
                    <LoadingIndicator />
                </View>
            </Container>
        );
    }

    _handleBack() {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }
}

const styles = StyleSheet.create({
    headerColor: {
        backgroundColor:"#fff"
    },

    headerIcon: {
        fontSize:30,
        color:"#777"
    },

    headerText: {
        fontSize: 20,
        color: "#333"
    },
});

export default ScreenLoadingIndicator;
